module.exports = __webpack_public_path__ + "static/media/wireframing.1ac06f78.jpg";